import { useMemo } from 'react';
import { usePromoteChannels } from '../../hooks/usePromoteChannels';
import { SerializedSocialChannel, SocialPlatform } from '../../types';
import { isCampaignChannel } from './reelsPlan/reelsPlanChannels';

export interface ReleasePlanChannels {
  /** The connected channels and the saved manual channels, in platform order: the default "Post on". */
  platforms: SocialPlatform[];
  /** The rows of those channels (the rollout run sheet reads Reconnect and the status). */
  channels: SerializedSocialChannel[];
  isLoading: boolean;
  error: ReturnType<typeof usePromoteChannels>['error'];
  retry: () => void;
}

/**
 * The channels a release plan posts on by default (designs f1, f2): every connected channel and
 * every saved manual channel, the same rule as the server. The channel list of the API also answers
 * a "manual" placeholder (`saved: false`) for each platform with no saved channel; the plan does not
 * list it (`isCampaignChannel`, the rule of the Auto campaign). The Plan tab, the Overview "Planned" panel
 * and the Auto campaign tab use the same list.
 */
export function useReleasePlanChannels(accountId: number): ReleasePlanChannels {
  const { channels, isLoading, error, retry } = usePromoteChannels({ accountId });
  const usable = useMemo(() => channels.filter(isCampaignChannel), [channels]);
  const platforms = useMemo(() => usable.map((channel) => channel.platform), [usable]);
  return { platforms, channels: usable, isLoading, error, retry };
}
